import axios from 'axios';

const APIs = {
  WORKING_TIME: '/working/working-time',
  OUTSIDE_REQUEST: '/working/outside-request',
  HOLIDAY_DAYS: '/working/holiday-days',
  WORKING_ASSIGNED_DAYS: '/working/working-assigned-days',
  OVERTIME_EVENTS: '/working/overtime-events',
  WORKING_SCHEDULE_EVENTS: '/working/working-schedule-events',
};

async function fetchGioiHanGioLamViec() {
  const { data } = await axios.get(`${APIs.WORKING_TIME}/gioi-han-gio-lam-viec`);
  return data;
}

async function updateGioiHanGioLamViec(payload: any) {
  const { data } = await axios.put(`${APIs.WORKING_TIME}/gioi-han-gio-lam-viec`, payload);
  return data;
}

async function fetchGioiHanGioLamViecByUser() {
  const { data } = await axios.get(`${APIs.WORKING_TIME}/gioi-han-gio-lam-viec-by-user`);
  return data;
}

async function fetchWorkingTimesByMonth(year: number, month: number) {
  const { data } = await axios.get(`${APIs.WORKING_TIME}/by-month`, {
    params: { year, month },
  });
  return data;
}

async function fetchAllUsersWorkingTimesByMonth(year: number, month: number, position: string) {
  const { data } = await axios.get(`${APIs.WORKING_TIME}/all-by-month`, {
    params: { year, month, position },
  });
  return data;
}

async function fetchRemainingLeaveHours(userID: number) {
  const { data } = await axios.get(`${APIs.WORKING_TIME}/leave-requests/remaining-hours`, { params: { userID } });
  return data;
}

async function createLeaveRequest(payload: {
  employeeId?: number;
  fullName?: string;
  leaveType: 'PAID' | 'UNPAID';
  startDate: string;
  endDate: string;
  reason?: string;
}) {
  const { data } = await axios.post(`${APIs.WORKING_TIME}/leave-requests`, payload);
  return data;
}

async function fetchLeaveRequests(params: { userId?: number; status?: string; search?: string, from?: any; to?: any }) {
  const { data } = await axios.get(`${APIs.WORKING_TIME}/leave-requests`, { params });
  return data;
}

async function approveLeaveRequest(id: number) {
  const { data } = await axios.put(`${APIs.WORKING_TIME}/leave-requests/${id}/approve`);
  return data;
}

async function rejectLeaveRequest(id: number, reason: string) {
  const { data } = await axios.put(`${APIs.WORKING_TIME}/leave-requests/${id}/reject`, { reason });
  return data;
}

async function cancelLeaveRequest(id: number) {
  const { data } = await axios.put(`${APIs.WORKING_TIME}/leave-requests/${id}/cancel`);
  return data;
}

async function fetchLeaveSummary(params: { year: number; search?: string }) {
  const { data } = await axios.get(`${APIs.WORKING_TIME}/leave-summary`, { params });
  return data;
}

async function fetchLeaveDetail(params: { userId: number; type: string; year: number }) {
  const { data } = await axios.get(`${APIs.WORKING_TIME}/leave-detail`, { params });
  return data;
}

async function createOutsideRequest(payload: {
  user_id?: number;
  outside_type: string;
  request_date: string;
  start_time: string;
  end_time: string;
  reason?: string;
  note?: string;
}) {
  const { data } = await axios.post(APIs.OUTSIDE_REQUEST, payload);
  return data;
}

async function fetchOutsideRequests(params: { userId?: number; status?: string; from?: any; to?: any; search?: string }) {
  const { data } = await axios.get(APIs.OUTSIDE_REQUEST, { params });
  return data;
}

async function updateOutsideRequestStatus(id: number, status: 'PENDING' | 'APPROVED' | 'REJECTED') {
  const { data } = await axios.put(`${APIs.OUTSIDE_REQUEST}/${id}/status`, { status });
  return data;
}

async function fetchHolidayDaysList() {
  const { data } = await axios.get(`${APIs.HOLIDAY_DAYS}`);
  return data;
}

async function createHolidayDay(payload: {
  title: string;
  from: string;
  to: string;
}) {
  const { data } = await axios.post(APIs.HOLIDAY_DAYS, payload);
  return data;
}

async function deleteHolidayDay(id: number) {
  const { data } = await axios.delete(`${APIs.HOLIDAY_DAYS}/${id}`);
  return data;
}

async function fetchWorkingAssignedDays(params: { from: string; to: string }) {
  const { data } = await axios.get(`${APIs.WORKING_ASSIGNED_DAYS}`, { params });
  return data;
}

async function fetchOvertimeEvents(from: string, to: string) {
  const { data } = await axios.get(`${APIs.OVERTIME_EVENTS}`, { params: { from, to } });
  return data;
}

async function fetchWorkingScheduleEvents(from: string, to: string) {
  const { data } = await axios.get(`${APIs.WORKING_SCHEDULE_EVENTS}`, { params: { from, to } });
  return data;
}

const WorkingTimeAPI = {
  fetchGioiHanGioLamViec,
  updateGioiHanGioLamViec,
  fetchGioiHanGioLamViecByUser,
  fetchWorkingTimesByMonth,
  fetchAllUsersWorkingTimesByMonth,
  fetchRemainingLeaveHours,
  createLeaveRequest,
  fetchLeaveRequests,
  approveLeaveRequest,
  rejectLeaveRequest,
  cancelLeaveRequest,
  fetchLeaveSummary,
  fetchLeaveDetail,
  createOutsideRequest,
  fetchOutsideRequests,
  updateOutsideRequestStatus,
  fetchHolidayDaysList,
  deleteHolidayDay,
  createHolidayDay,
  fetchWorkingAssignedDays,
  fetchOvertimeEvents,
  fetchWorkingScheduleEvents,
};

export default WorkingTimeAPI;
